module.exports = __webpack_public_path__ + "static/media/own_delivery_reports.1c10267d.svg";